module.exports = __webpack_public_path__ + "img/photo-01.859fdf11.jpg";